import { ConnectDisputesList } from '@stripe/react-connect-js'
import { STRIPE_CONNECT_DASHBOARDLESS_SECTIONS } from '@/components/stripe-connect/stripeConnectSurfaceContent'
import { createFileRoute } from '@tanstack/react-router'
import { ShieldAlert } from 'lucide-react'
import { DashboardlessStripePage, dashboardlessStripeRouteLoader } from './-dashboardless-page'

const section = STRIPE_CONNECT_DASHBOARDLESS_SECTIONS.disputes

export const Route = createFileRoute('/_authenticated/$orgId/settings/stripe/disputes')({
  component: StripeDisputesPage,
  loader: dashboardlessStripeRouteLoader,
})

export function StripeDisputesPage() {
  return (
    <DashboardlessStripePage
      {...section}
      icon={ShieldAlert}
      sections={[{ ...section, component: ConnectDisputesList }]}
      surface="disputes"
    />
  )
}
